import {
  Button,
  // Callout,
  Classes,
  ControlGroup,
  Dialog,
  FormGroup,
  Tag,
  TextArea,
} from "@blueprintjs/core";
import { Users } from "@just-in-types";
import * as React from "react";
import { firestore } from "../../../firebase";

interface Props {
  checkIn: Users.CheckIn;
  handleUserNote:any;
}

interface State {
  isOpen: boolean;
  markUserNotes?: boolean;
  noteInput: string;
  userNote: string;
}

class NotesDialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
      markUserNotes: false,
      noteInput: "",
      userNote: "",
    };
  }

  public componentDidUpdate({ checkIn: prevCheckIn }: Props) {
    const { checkIn } = this.props;
    if (prevCheckIn.checkInId !== checkIn.checkInId) {
      this.noteUser(checkIn);
      this.setState({ markUserNotes: checkIn.markUserNotes});
    }
  }

  public render() {
    const { isOpen, markUserNotes, noteInput, userNote } = this.state;
    const dialogProps: Dialog["props"] = {
      canEscapeKeyClose: true,
      canOutsideClickClose: true,
      isOpen,
      onClose: this.toggleModal,
      title: "Notes",
    };
    return (
      <>
        {markUserNotes?(
          <span>
            <Button className="grayclr" disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} style={{ background:"#9B9B9B",marginBottom: "0.5rem" }} onClick={this.toggleModal}>
              Add Note
            </Button>
            <span className="left-side-undo-icon">
              <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} icon="undo" style={{background:"#9B9B9B",marginBottom:"10px",marginLeft:"10px"}} onClick={this.undoMarkUserNotes} />
            </span>
          </span>
        ):
          (
            <Button className="greenclr" disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} style={{ background:"#0D8050",marginBottom: "0.5rem" }} onClick={this.toggleModal}>
              Add Note
            </Button>
  
          )
        }

        {/* {userNote && (
          <Callout
            title="Important Note"
            intent="success"
            style={{ marginBottom: "0.5rem" }}
          >
            {userNote}
          </Callout>
        )} */}
        <Dialog {...dialogProps}>
          <div className={Classes.DIALOG_BODY}>
            <ControlGroup fill={true}>
              <FormGroup
                helperText={"Please add note here..."}
                label={"Note"}
                labelFor="text-note"
              >
                <TextArea
                  name="noteInput"
                  onChange={this.handleInputChange}
                  value={noteInput}
                />
              </FormGroup>
            </ControlGroup>

            <ControlGroup fill={true}>
              <FormGroup>
                <Button style={{ background:'#0D8050', color:'#fff', borderRadius:'5px'}} onClick={this.handleAddNoteButton}>
                  Add Note
                </Button>
              </FormGroup>
            </ControlGroup>

            {userNote && (
              <ControlGroup
                fill={true}
                style={{
                  display: "grid",
                  gridTemplateColumns: "30% 1fr",
                  marginBottom: "0.5rem",
                }}
              >
                <Tag large={true} style={{ marginTop: 5 }}>
                  Note
                </Tag>
                <Tag
                  interactive={true}
                  large={true}
                  minimal={true}
                  style={{ marginTop: 5, padding: 5 }}
                >
                  {userNote}
                </Tag>
              </ControlGroup>
            )}
          </div>
        </Dialog>
      </>
    );
  }

  private toggleModal = () =>
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  private undoMarkUserNotes = async () =>{
    const { checkIn } = this.props;
    try {
      await firestore
        .collection("notes")
        .doc(checkIn.userId)
        .update({
          note: null
        });
    } catch (error) {
      throw new Error(error);
    }

    try {
      await firestore
        .collection("checkIns")
        .doc(checkIn.checkInId)
        .update({
          'markUserNotes': false
        });
    } catch (error) {
      throw new Error(error);
    }
    this.setState({ markUserNotes: false});
  }

  private handleAddNoteButton = async () => {
    const { checkIn } = this.props;
    const { noteInput } = this.state;



    if (checkIn && noteInput) {
      await firestore
        .collection(`notes`)
        .doc(checkIn.userId)
        .set({
          businessId: checkIn.businessId,
          checkInId: checkIn.checkInId,
          createdAt: new Date().valueOf(),
          mobile: checkIn.mobile,
          note: noteInput,
        });
        try {
          await firestore
            .collection("checkIns")
            .doc(checkIn.checkInId)
            .update({
              'markUserNotes': true
            });
        } catch (error) {
          throw new Error(error);
        }
      this.props.handleUserNote();
      this.setState({ markUserNotes: true, userNote: noteInput });
    }

    this.setState({ isOpen: false, noteInput: "" });
  };

  private handleInputChange = (event) => {
    const { name, value } = event.currentTarget;
    if (name === "noteInput") {
      const noteInput = value;
      this.setState({ noteInput });
    }
  };

  private noteUser = async (checkIn: Users.CheckIn) => {
    firestore
      .collection("notes")
      .where("businessId", "==", checkIn.businessId)
      .where("mobile", "==", checkIn.mobile)
      .onSnapshot((snapshot) => {
        let userNote = "";
        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            const noteData = doc.data();
            userNote = noteData.note;
          });
        }
        this.setState({ userNote });
      });
  };
}

export default NotesDialog;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/NotesDialog.tsx